import { message } from "antd"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { errorText } from "../api/errors.ts"
import { createAnalysis, linkStoredFile } from "../api/services.ts"
import { openFpeWizard } from "./fpe-task-store.ts"

export interface StoredFileRef {
  source: "document" | "file"
  id: string
}

export interface StartPlanOptions {
  /** The lead or project the plan is for, already chosen by where it was started. */
  target?: string | null
  /** Started inside that record: the plan belongs to it and can't be moved. */
  lockTarget?: boolean
  /** Files already stored in EZBuild, linked by id (never uploaded again). The first
   *  is the customer document, the rest supporting. */
  files?: StoredFileRef[]
}

// "Start a plan": a new draft opened in the wizard on its first step. The draft is the
// server's analysis record, so nothing is lost if it is closed.
export function useStartPlan() {
  const { t } = useTranslation()
  const [starting, setStarting] = useState(false)
  const start = async (options: StartPlanOptions = {}) => {
    if (starting) return
    setStarting(true)
    try {
      const created = await createAnalysis({
        name: "",
        ...(options.target
          ? {
              target: options.target,
              ...(options.lockTarget ? { lock_target: true } : {})
            }
          : {})
      })
      for (const [index, file] of (options.files ?? []).entries()) {
        try {
          await linkStoredFile(
            created.id,
            file,
            index === 0 ? "primary" : "supporting"
          )
        } catch (e) {
          message.error(errorText(e, t))
        }
      }
      openFpeWizard(created.id, { step: "destination" })
      return created.id
    } catch (e) {
      message.error(errorText(e, t))
    } finally {
      setStarting(false)
    }
  }
  return { start, starting }
}
